import React, { useState } from "react";
import Breadcrumb from "../Header/Breadcrumb";
import Header from "../Header/Header";
import LayoutContent from "../LayoutContent";
import HeaderSelector from "../Header/HeaderSelector";
import { DisplayValue } from "../PlateTypeEditor/DefaultImagingSettingViews/DefaultImagingSettingComboBox";
import SimulatedScannedBarcodeEditor from "./SimulatedScannedBarcodeEditor";
import SimulationSensorToggler from "./SimulationSensorToggler";
import SimulationMotor from "./SimulationMotor";
import { EModuleType } from "../../Model/EModuleType";
import ToolsNavSubMenu from "../Tools/ToolsNavSubMenu";

const LP_BARCODE = "LP_BARCODE";
const C_BARCODE = "C_BARCODE";
const SENSOR = "SENSOR";
const MOTOR = "MOTOR";

const displayValues: DisplayValue[] = [
  {
    display: "Load Port Barcode Scanner",
    value: LP_BARCODE,
  },
  {
    display: "Storage Barcode Scanner",
    value: C_BARCODE,
  },
  {
    display: "Sensor",
    value: SENSOR,
  },
  {
    display: "Motor",
    value: MOTOR,
  },
];

export default function SimulationView() {
  const [body, setBody] = useState(SENSOR);
  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              { title: "Simulation", to: "/simulation", disabled: false },
            ]}
          />
          <HeaderSelector
            displayValues={displayValues}
            value={body}
            onChange={setBody}
          />
        </Header>
      </LayoutContent.Header>
      <LayoutContent.Content>
        <>
          {body === LP_BARCODE && (
            <SimulatedScannedBarcodeEditor moduleType={EModuleType.LOADPORT} />
          )}
          {body === C_BARCODE && (
            <SimulatedScannedBarcodeEditor moduleType={EModuleType.CHAMBER} />
          )}
          {body === SENSOR && <SimulationSensorToggler />}
          {body === MOTOR && <SimulationMotor />}
        </>
      </LayoutContent.Content>
      <LayoutContent.SubMenu>
        <ToolsNavSubMenu />
      </LayoutContent.SubMenu>
    </LayoutContent>
  );
}
